<template>
  <v-container
    fill-height
    class="ma-0"
    fluid
  >
    <v-row class="ma-0 pa-0">
      <v-col
        v-for="(value, index) in [...Array(months)]"
        :key="index"
        :style="style"
      >
        <CalendarNavigation
          v-if="selectedObject.calendar"
          :plus-months="index"
          :show-legend="index === 0"
          :show-overlay="!selectedObject.calendar"
        />
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import sharedMethods from '../../methods/sharedMethods'
import api from '../../store/api'
import CalendarNavigation from './CalendarNavigation'
import { createHelpers } from 'vuex-map-fields'
import state from '../../store/state.js'
const { mapFields } = createHelpers({
  getterType: 'getField',
  mutationType: 'updateField',
})

export default {
  name: 'Object',

  data() {
    return {
      calendarObjectId: null,
      loaded: false,
      itemsPerRow: 1,
      months: 3,
    }
  },

  metaInfo() {
    return this.getMetaTags()
  },

  components: {
    CalendarNavigation,
  },

  computed: {
    ...mapFields(Object.keys(state)),

    style() {
      return {
        padding: '0 15px 15px 0',
        width: 100 / this.itemsPerRow + '%',
      }
    },

    datePeriodComputed() {
      return this.searchFilters.dateStart + '_' + this.searchFilters.dateEnd
    },

    // TODO - double?
    showingMobileFullImages() {
      return (
        !this.$vuetify.breakpoint.mdAndUp &&
        this.showingFullImage &&
        this.selectedObject.objectImages &&
        this.selectedObject.objectImages.length > 0
      )
    },
  },

  created() {
    this.itemsPerRow = Math.floor(window.innerWidth / 250)
    if (this.itemsPerRow < 1) {
      this.itemsPerRow = 1
    }

    const urlParams = new URLSearchParams(window.location.search)
    if (urlParams.get('itemsPerRow')) {
      this.itemsPerRow = urlParams.get('itemsPerRow')
    }
    if (urlParams.get('months')) {
      this.months = parseInt(urlParams.get('months'))
    }
    this.calendarObjectId = this.$route.params.objectId
    this.getObjectInfo(this.calendarObjectId)
  },

  methods: {
    ...sharedMethods,

    getObjectInfo(objectId) {
      return new Promise((resolve) => {
        const filters = []
        return api
          .getOneItemWithQuery('objects', objectId, filters)
          .then((result) => {
            if (!result.objectImages) {
              resolve(false)
              return
            }
            // Sort images
            result.objectImages = result.objectImages.sort((a, b) =>
              parseInt(a.sortOrder) > parseInt(b.sortOrder) ? 1 : -1
            )
            this.selectedObject = result
            this.loaded = true
            resolve(true)
          })
      })
    },
  },
}
</script>

<style>
body:before {
  /* background: white !important; */
}
</style>
